import { Flex, Modal } from 'components';
import { P } from 'components/Typography/Typography';
import { t } from 'i18next';
import { Dispatch } from 'react';
import styled from 'styled-components';

const BulletList = styled.ul`
  margin: 0 0 20px 0;
  padding-left: 0;
  list-style: none;
  font-size: 13px;
  line-height: 1.45;
  color: ${({ theme }) => theme.palette.text.primary};
`;

const BulletItem = styled.li`
  position: relative;
  padding-left: 16px;
  margin-bottom: 10px;

  &::before {
    content: '-';
    position: absolute;
    left: 0;
    top: 0;
    color: ${({ theme }) => theme.palette.text.primary};
    font-weight: 600;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const BodyWarningTitle = styled.p`
  margin: 0 0 10px 0;
  color: ${({ theme }) => theme.palette.text.red};
  font-weight: 700;
  font-size: 13px;
  line-height: 1.4;
`;

interface Props {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<React.SetStateAction<boolean>>;
}

export const PasswordErrorModal = ({ isModalOpen, setIsModalOpen }: Props) => {
  return (
    <Modal
      isOpen={isModalOpen}
      onCancelClick={() => {
        setIsModalOpen(false);
      }}
      headerTitle={
        <span style={{ fontWeight: 700 }}>
          {t('profile.passwordError.modalTitle')}
        </span>
      }
      headerTitleColor="red"
      gridTemplateColumns="min(480px, 92vw)"
      mainButton={{
        label: t('buttons.close'),
        action: () => {
          setIsModalOpen(false);
        },
        variant: 'grey'
      }}
    >
      <Flex flexDirection="column" maxWidth="100%">
        <BodyWarningTitle role="heading" aria-level={3}>
          {t('profile.passwordError.bodyTitle')}
        </BodyWarningTitle>
        <BulletList>
          <BulletItem>
            {t('profile.passwordError.items.username')}
          </BulletItem>
          <BulletItem>
            {t('profile.passwordError.items.name')}
          </BulletItem>
          <BulletItem>
            {t('profile.passwordError.items.company')}
          </BulletItem>
          <BulletItem>
            {t('profile.passwordError.items.family')}
          </BulletItem>
          <BulletItem>
            {t('profile.passwordError.items.keyboard')}
          </BulletItem>
          <BulletItem>
            {t('profile.passwordError.items.common')}
          </BulletItem>
        </BulletList>

        <Flex flexDirection="column" mt={1}>
          <P variant="body" fontWeight={700}>
            {t(
              'profile.passwordError.suggestionTitle'
            )}
          </P>
          <P variant="body" color="green" fontWeight={700} mt={2} mb={2}>
            {t(
              'profile.passwordError.suggestionExample'
            )}
          </P>
        </Flex>
      </Flex>
    </Modal>
  );
};
